<app-model-site-header
  [label]="'Add Existing User'"
  [backUrl]="'/' + companyId + '/users'"
></app-model-site-header>
<div class="reset-nb-layout">
  <nb-layout-column>
    <nb-card class="content-card model-form">
      <nb-card-header><h1>Add Existing User</h1> </nb-card-header>
      <nb-card-body>
        <form (ngSubmit)="onSubmit()" [formGroup]="form">
          <div class="model-form__section">
            <label for="email" class="model-form__label">Email</label>
            <input
              #autoInput
              nbInput
              id="email"
              type="text"
              placeholder="Email"
              formControlName="email"
              (input)="onEmailChange()"
              [nbAutocomplete]="auto"
              autocomplete="off"
            />

            <nb-autocomplete #auto (selectedChange)="onEmailSelectionChange($event)">
              <nb-option *ngFor="let option of filteredEmailOptions$ | async" [value]="option">
                {{ option }}
              </nb-option>
            </nb-autocomplete>

            <div class="text text--error" *ngIf="required('email')">Email is required</div>
          </div>
          <div class="model-form__button-container">
            <button [disabled]="!form.valid" type="submit" nbButton status="primary">
              Submit
            </button>
          </div>
        </form>
      </nb-card-body>
    </nb-card>
  </nb-layout-column>
</div>
